import React, { useEffect, useState, useContext } from 'react';
import * as styledComponents from './styles';
import { Container, Row } from 'react-bootstrap';
import ItemElement from './CartElement';
import DetailItem from '../components/DetailItem/index.tsx';
import Modal from 'react-modal';
import Checkout from '../Checkout';
import ArrowRight from "./ArrowRight";
import { CartContext } from 'contexts/CartContext';
import { useHistory } from "react-router";
import { useAlert } from 'react-alert'

const modalStyle = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.70)',
    zIndex: '100',
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    height: '900px',
    maxHeight: '80%',
    width: '600px',
    maxWidth: '95%',
    padding: '80px 20px',
    zIndex: '101',
    background: 'linear-gradient(169.29deg, #262B2F -0.68%, #16191D 74.03%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    border: 'none',
  },
};


const checkoutStyle = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.70)',
    zIndex: '100',
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    height: '500px',
    maxHeight: '80%',
    width: '500px',
    maxWidth: '95%',
    padding: '20px 5px',
    zIndex: '101',
    background: 'linear-gradient(169.29deg, #262B2F -0.68%, #16191D 74.03%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    border: 'none',
  },
};

const ShopItems = () => {
  const [detailIsOpen, setDetailIsOpen] = useState(false);
  const [focusedItem, setFocusedItem] = useState(0);
  const { cart, updateCart } = useContext(CartContext);
  const [checkoutShown, setCheckoutShown] = useState(false);
  const history = useHistory();
  const alert = useAlert();

  const toggleDetail = ()=>{
    setDetailIsOpen(!detailIsOpen);
  }

  const deleteItem = (item)=>{
    const newCart = [...cart];
    const index = cart.indexOf(item);
    if (index > -1) {
      newCart.splice(index, 1);
    }
    updateCart(newCart);
    alert.show(`${item.name} removed`, {type: 'info'});

  }

  useEffect(() => {
    Modal.setAppElement('#root');
  }, []);
  
  const toggleCheckout = ()=>{
    setCheckoutShown(!checkoutShown);
  }

  const fullPaymentDone = ()=>{
    setCheckoutShown(false);
    updateCart([]);
  }

  return (
    <styledComponents.CartContainer>
      <Modal
        style={modalStyle}
        isOpen={detailIsOpen}
        onRequestClose={toggleDetail}
      >
        {cart?.length && <DetailItem item={cart[focusedItem]} toggleDetail={toggleDetail} hiddenAdd/>}
      </Modal>
      <Modal
        style={checkoutStyle}
        isOpen={checkoutShown}
        onRequestClose={toggleCheckout}
      >
        <Checkout fullPaymentDone={fullPaymentDone} cart={cart}/>
      </Modal>
      <Container>
          <styledComponents.ContainerBreadcrumbs> <styledComponents.ShopLink onClick={()=>{history.push('/shop')}}>Shop</styledComponents.ShopLink> <ArrowRight /> Cart</styledComponents.ContainerBreadcrumbs>
          {cart?.map((item, idx) => {
            return <ItemElement deleteItem={deleteItem} key={idx} item={item} toggleDetail={toggleDetail} setFocusedItem={setFocusedItem}/>
          })}
          {!cart?.length && <styledComponents.CartEmptyIndicator><i>Your cart is empty. Would you like to explore our services?</i></styledComponents.CartEmptyIndicator>}

        {cart?.length  
          ? <styledComponents.CallToAction onClick={toggleCheckout}>CONFIRM ORDER</styledComponents.CallToAction>
          : <styledComponents.CallToAction onClick={()=>{history.push('/shop')}}>EXPLORE SERVICES</styledComponents.CallToAction>
        }
      </Container>
    </styledComponents.CartContainer>
  );
}

export default ShopItems;
